export const templateGzHeader = document.createElement('template');

templateGzHeader.innerHTML = `
  <gz-header-ui></gz-header-ui>
`;
